
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wholesale",
      function () {
        return require("private-next-pages/wholesale.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wholesale"])
      });
    }
  